import React, { useState } from 'react';
import { browserHistory } from 'react-router';
import { api as API } from '@/mixins/api';

import { PageContainer, TwoColumnLayout } from '@repo/ui/components/layout/PageLayouts';
import { SecondaryHeader } from '@repo/ui/components/typography/Headers';
import TimeLogger from './TimeLogger';
import { hoursBetween } from '@repo/utils/Chrono';
import TimeEditor from './TimeEditor';

export default function ShiftLogger({ user, loggable, params, reloadLoggable }) {
  const [submitting, setSubmitting] = useState(false);

  const getDetails = () => {
    const app = loggable.find((l) => l.slug === params.applicationSlug);
    const { shifts = [] } = app || {};
    const shift = shifts.find((s) => s.id === params.shiftId);
    const shiftDate = shift.schedule.find((sch) => sch.starts === params.startDate);
    return { app, shift, shiftDate };
  };

  const handleSubmit = (data, _, __, handleServerResponse) => {
    setSubmitting(true); // Disable submit button to prevent double-submits
    const { shiftDate, app } = getDetails();
    API.makeRequest(
      `/hours/shift/${params.shiftId}`,
      'POST',
      {
        startDate: shiftDate.starts,
        feedback: data.feedback,
        rating: data.rating,
        hours: data.hours,
        business: data.business,
      },
      handleServerResponse((res) => {
        if (res) {
          reloadLoggable();
          browserHistory.push({
            pathname: '/user/log-hours/thanks',
            state: { logged: { ...data, roleName: app.roleName } },
          });
        } else {
          // Only need to set submitting to false if the request failed, otherwise it navs away and there's no point
          setSubmitting(false);
        }
      }),
    );
  };

  const handleEditSubmit = (data, _, __, handleServerResponse) => {
    const { shiftDate, app } = getDetails();

    setSubmitting(true); // Disable submit button to prevent double-submits
    API.makeRequest(
      `/hours/${shiftDate.hourIds[0]}`,
      'PUT',
      {
        hours: data.hours,
      },
      handleServerResponse((res) => {
        if (res) {
          reloadLoggable();
          browserHistory.push({
            pathname: '/user/log-hours/thanks',
            state: { logged: { ...data, roleName: app.roleName } },
          });
        } else {
          // Only need to set submitting to false if the request failed, otherwise it navs away and there's no point
          setSubmitting(false);
        }
      }),
    );
  };

  const { shift, shiftDate } = getDetails();
  if (!shiftDate) return <SecondaryHeader>Can't find specific shift date</SecondaryHeader>;

  const defaultHours =
    shift.suggestedHours || hoursBetween(shiftDate.starts, shiftDate.ends, false);
  const existingHours = shiftDate.hours;
  const existingHourIds = shiftDate.hourIds || [];

  // NOTE: Only allows editing if there's exactly one hour record for this shift date -- since otherwise we don't know which one to edit and the number given is a sum
  return (
    <PageContainer>
      <TwoColumnLayout side={<div />}>
        {existingHours && existingHourIds.length === 1 ? (
          <TimeEditor
            value={{ hours: existingHours, startDate: shiftDate.starts }}
            onSubmit={handleEditSubmit}
          />
        ) : (
          <TimeLogger
            notice={
              existingHours && existingHourIds.length === 0
                ? 'noEditableHours'
                : existingHours && existingHourIds.length > 1
                  ? 'tooManyHourRecords'
                  : null
            }
            loading={submitting}
            user={user}
            value={{ hours: defaultHours }}
            onSubmit={handleSubmit}
          />
        )}
      </TwoColumnLayout>
    </PageContainer>
  );
}
